/* eslint-disable no-empty */
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { InputGroup, InputGroupAddon } from "reactstrap";

import DropDown from "components/DropDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextareaAutosize from "react-autosize-textarea";
import { ADMIN_ROLE, MANAGER_ROLE } from "constants/role.constant";

const searchOptionData = [
  {
    label: "Order ID",
    value: "clientOrderNo"
  },
  {
    label: "AWB No.",
    value: "AWBNo"
  },
  {
    label: "Consignee Number",
    value: "deliveryContact"
  }
];

const searchOptionDataForAdmin = [
  {
    label: "Order ID",
    value: "clientOrderNo"
  },
  {
    label: "AWB No.",
    value: "AWBNo"
  },
  {
    label: "Consignee Number",
    value: "deliveryContact"
  },
  {
    label: "3PL AWB No",
    value: "tplAWBNo"
  },
  {
    label: "FBA ID",
    value: "IQAMA_ID"
  }
];

const SearchInput = ({ onHandleSearch, onClearSearch, searchOptions, handleOnChange }) => {
  const [searchBy, setSearchBy] = useState("AWBNo");
  const [searchValue, setSearchValue] = useState("");
  const [searchOption, setSearchOptions] = useState(searchOptions ? searchOptions : searchOptionData);

  useEffect(() => {
    // Check user role
    const userRole = localStorage.getItem("role");
    if (searchOptions) {
      const defaultOption = searchOptions.find((option) => option.default) || searchOptions[0];
      setSearchBy(defaultOption.value);

      setSearchOptions(searchOptions);
    } else if (
      userRole &&
      (
        userRole.toUpperCase() === ADMIN_ROLE
        || userRole.toUpperCase() === MANAGER_ROLE
        || userRole.startsWith("EMPLOYEE")
      )
    ) {
      // Need to add only for Admin & Employee user
      setSearchOptions(searchOptionDataForAdmin);
    } else {
      setSearchOptions(searchOptionData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchOptions]);

  /**
   * Convert string to array
   * @param {*} searchValue
   */
  const getInputValue = (searchValue) => {
    let values = [];
    try {
      values = searchValue.trim();
      values = values.replace(/\n/g, " ");
      values = values.split(" ");

      if (values && values.length === 1 && values[0] === "") {
        values = [];
      }
    } catch (error) { }
    return values;
  };

  const onSearchClick = (searchText) => {
    if (!searchBy) {
      toast.error("Select search by to proceed");
      return;
    }

    // Generate filter data
    let filter = {};
    const values = getInputValue(searchText || searchValue);
    filter[searchBy] = values;

    // Callback/trigger search event
    onHandleSearch(filter);
  };

  const onClearSearchClick = () => {
    setSearchValue("");
    onClearSearch();
  };

  return (
    <InputGroup
      className="border border-primary"
      style={{ border: "2px solid", alignItems: "center" }}>
      <InputGroupAddon addonType="prepend">
        <DropDown
          options={searchOption}
          selectLabel="Search by:"
          value={searchBy}
          onChange={(e) => setSearchBy(e.target.value)}
          className="bg-primary px-3 m-0 border-0 rounded-0"
          containerClassName="m-0"
        />
      </InputGroupAddon>
      <TextareaAutosize
        className="form-control"
        style={{ maxHeight: 100, boxSizing: "border-box", borderRadius: 0 }}
        value={searchValue}
        onChange={(e) => {
          setSearchValue(e.target.value);
          if (handleOnChange) {
            onSearchClick(e.target.value);
          }
        }}
        onKeyPress={(e) => (e.key === "Enter" ? onSearchClick() : null)}
      />
      {searchValue && (
        <InputGroupAddon addonType="append">
          <FontAwesomeIcon
            onClick={() => onClearSearchClick(searchValue)}
            size="lg"
            icon={["fas", "times-circle"]}
            style={{ marginLeft: "5px", paddingRight: "5px" }}
          />
        </InputGroupAddon>
      )}
    </InputGroup>
  );
};

export default SearchInput;
